import {
  DataTable,
  ModalConfirmAction,
  PageWrapper,
  PROFILE_URL_PATH,
  STATUSPAGE,
} from '@repo/ui';
import { PROFILE_TYPE } from 'domain/value-objects/profile-type';
import { useFormik } from 'formik';
import { useEffect } from 'react';
import { Card, CardBody, Form, Row } from 'reactstrap';
import * as Yup from 'yup';

import { makeColumnsProfessionalsLists } from '../../../common/columns/columns-professionals-lists';
import { AssistantsOrAuxiliariesFilters } from '../../../components/assistants-or-auxiliaries-filters';
import { useProfessionalsLists } from '../../../hooks/useProfessionalsLists';

export const AuxiliariesList = () => {
  // Hooks
  const {
    listStatusPage,
    isUnlinkModalOpen,
    professionalsData,
    paginationMetadata,
    selectedProfessionalId,
    unlinkModalButtonsStatusPage,
    debouncedRequestGetAllProfessionals,
    navigate,
    toggleUnlinkModal,
    handleSearchRemote,
    handleSortRemote,
    handlePageChange,
    setListStatusPage,
    removeProfessionalsData,
    handleRowsPerPageChange,
    requestUnlinkProfessional,
  } = useProfessionalsLists();

  // Form Validation
  const validation = useFormik({
    initialValues: {
      entity: null,
      course: null,
    },
    validationSchema: Yup.object({
      entity: Yup.object()
        .shape({
          label: Yup.string(),
          value: Yup.string(),
        })
        .nullable(),
      course: Yup.object()
        .shape({
          label: Yup.string(),
          value: Yup.string(),
        })
        .nullable(),
    }),

    // There is no onSubmit function on this form (no submit button).
    // The API request is sent everytime any filter changes, so it is controlled via useEffect and DataTable's remote pagination.
    onSubmit: () => {
      return;
    },
  });

  // useEffect responsible for calling API and fetching DataTable's data
  useEffect(() => {
    const valuesToSubmit = {
      entity: validation.values?.entity?.value,
      course: validation.values?.course?.value,
      page: paginationMetadata.selectedPage.toString(),
      length: paginationMetadata.rowsPerPage.toString(),
      order: paginationMetadata.sortDirection,
      orderColumn: paginationMetadata.orderColumn,
      query: paginationMetadata.searchString,
      profileType: PROFILE_TYPE.ADMINISTRATIVE,
    };
    setListStatusPage(STATUSPAGE.LOADING);

    debouncedRequestGetAllProfessionals(valuesToSubmit);

    return () => {
      removeProfessionalsData();
    };
  }, [
    validation.values?.entity,
    validation.values?.course,
    paginationMetadata,
  ]);

  // Constants
  const noDataConfig = {
    noDataTitle: 'Nenhum auxiliar encontrado',
    noDataDescription:
      'Use os filtros acima para pesquisar auxiliares por nome, organização ou curso.',
  };

  return (
    <PageWrapper title="Auxiliares">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4>Auxiliares</h4>
        {/* <button
          type="submit"
          className="btn btn-primary waves-effect waves-light d-flex align-items-center gap-1"
          onClick={() => {
            navigate(`/pre-cadastro/${PROFILE_URL_PATH.AUXILIARIES}`);
          }}
        >
          <i className="ri-add-line" style={{ fontSize: '1rem' }}></i>
          Novo Auxiliar
        </button> */}
      </div>
      <Card>
        <Form
          autoComplete="off"
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          <CardBody>
            <Row>
              <AssistantsOrAuxiliariesFilters validation={validation} />
            </Row>
          </CardBody>
        </Form>

        <CardBody>
          <DataTable
            noDataTitle={noDataConfig.noDataTitle}
            noDataDescription={noDataConfig.noDataDescription}
            actions={[
              {
                id: 1,
                name: 'overview',
                label: 'Visão Geral',
                onPress: (cellProps) => {
                  navigate({
                    pathname: `/gerenciamento-de-profissional/${PROFILE_URL_PATH.AUXILIARIES}/${cellProps.id}`,
                    search: '?painel=visao-geral',
                  });
                },
                icon: 'ri-line-chart-line',
                classNameColorIcon: 'primary',
              },
              {
                id: 2,
                name: 'view',
                label: 'Visualizar',
                onPress: (cellProps) => {
                  navigate({
                    pathname: `/gerenciamento-de-profissional/${PROFILE_URL_PATH.AUXILIARIES}/${cellProps.id}`,
                    search: '?painel=dados-cadastrais',
                  });
                },
                icon: 'ri-file-search-line',
                classNameColorIcon: 'primary',
              },
              // {
              //   id: 2,
              //   name: 'unlink',
              //   label: 'Desvincular',
              //   icon: 'ri-indeterminate-circle-fill',
              //   classNameColorIcon: 'danger',
              //   onPress: (cellProps) => {
              //     setSelectedProfessionalId(cellProps.id);
              //     toggleUnlinkModal();
              //   },
              // },
              // {
              //   id: 3,
              //   name: 'edit',
              //   label: 'Editar',
              //   onPress: (cellProps) => {
              //     navigate(
              //       `/gerenciamento-de-profissional/${PROFILE_URL_PATH.AUXILIARIES}/editar/${cellProps.id}`, - to change in privateRoutes later
              //     );
              //   },
              //   icon: 'ri-edit-line',
              //   classNameColorIcon: 'primary',
              // },
            ]}
            canSearch
            searchServer
            onSearch={handleSearchRemote}
            columns={makeColumnsProfessionalsLists()}
            data={professionalsData?.data || []}
            loading={listStatusPage === STATUSPAGE.LOADING}
            pagination
            paginationServer
            paginationTotalRows={professionalsData?.total}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handleRowsPerPageChange}
            sortServer
            onSort={handleSortRemote}
          />
        </CardBody>
      </Card>

      <ModalConfirmAction
        title="Deseja desvincular?"
        modalTheme="danger"
        isOpen={isUnlinkModalOpen}
        toggle={toggleUnlinkModal}
        onConfirm={() =>
          requestUnlinkProfessional(
            { id: selectedProfessionalId },
            PROFILE_TYPE.ASSISTANT,
          )
        }
        loading={unlinkModalButtonsStatusPage === STATUSPAGE.LOADING}
      />
    </PageWrapper>
  );
};
